import React from 'react';
import cls from '@utils/css-select';
import styles from './styles.scss';
import { useTranslation } from 'hooks/use-translation';

const cx = cls(styles);

function Tabs(props: { activeId: number; tabClick: (id: number) => void }) {
	const { transData } = useTranslation('perfilAndAjustes');

	const tabArr = [
		{ id: 1, cont: transData.courses },
		{ id: 2, cont: transData.ProfileInfor },
		{ id: 3, cont: transData.TransRecord },
	];
	const activeId = props.activeId;
	return (
		<div className={cx('tabs-container')}>
			{tabArr.map((tab) => {
				return (
					<span key={tab.id} onClick={() => props.tabClick(tab.id)} className={cx('tab-text', { 'tab-text-active': activeId === tab.id })}>
						{tab.cont}
					</span>
				);
			})}
		</div>
	);
}

export default Tabs;
